import CreateCustomerPage from "./CreateCustomerPage";
export default CreateCustomerPage;
